import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";
import ScrollProgress from "@/components/site/ScrollProgress";
import LandingSections from "@/components/site/LandingSections";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import {
  organizationSchema,
  websiteSchema,
  personSchema,
  physicianSchema,
  OG_IMAGES, SITE_URL} from "@/lib/seo";

export default function Landing() {
  useDocumentMeta({
    title: "Integrated Wellness | Integrated Clinical Intelligence for Personalized Health Optimization",
    description:
      "Integrated Wellness combines your goals, symptoms, labs, body composition, wearables, genetics, microbiome data and health history into one intelligent optimization profile — helping you and your clinical team understand what to optimize next.",
    image: OG_IMAGES.home,
    url: `${SITE_URL}/`,
    schema: [organizationSchema(), websiteSchema(), personSchema(), physicianSchema()],
  });

  return (
    <div data-testid="landing-page" className="min-h-screen bg-background">
      <ScrollProgress />
      <Header />
      <LandingSections />
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
